<template>
  <div>
    <div class="realbody">
      <div class="top_summary">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <p class="top_summary_header mplus2p-m spacing4 noiseblack" style="text-align:justify">
                {{$t('privacy_title')}}</p>
              <p class="top_summary_comment mplus2p-r spacing1-2 noiseblack" style="text-align:justify">
                {{$t('privacy_subtitle')}}</p>
            </div>
            <div class="col-md-6 inquryimg ">
              <img src="../../../assets/imgs/illust-enginner-section-link.png"/>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="col-md-12">
          <div class="tab-content panels-faq">
            <div class="tab-pane active" id="tab1">
              <div class="panel-group" id="help-accordion-1">
                <div class="panel panel-default panel-help">
                  <a href="#privacy-policy-1" data-toggle="collapse" data-parent="#help-accordion-1">
                    <div class="panel-heading">
                      <h2>1. 個人情報の定義、適用範囲 <i class="fa fa-angle-down fa-lg"></i></h2>
                    </div>
                  </a>
                  <div id="privacy-policy-1" class="collapse in">
                    <div class="panel-body">
                      <p>
                        本ポリシーにおける「個人情報」とは、個人に関する情報で、当該情報に含まれる一定の情報により、特定の個人を識別し得る情報をいいます。但し、当社が運営するWebサイト（以下、｢当社サイト｣といいます。）内のリンク先のウェブサイト、その他弊社が直接管理していないWebサイト等に登録された個人情報は、本ポリシーの適用範囲外とします。</p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default panel-help">
                  <a href="#privacy-policy-2" data-toggle="collapse" data-parent="#help-accordion-1">
                    <div class="panel-heading">
                      <h2>2. 個人情報に関する法令、国の定める指針、その他の規範の遵守 <i class="fa fa-angle-down fa-lg"></i></h2>
                    </div>
                  </a>
                  <div id="privacy-policy-2" class="collapse">
                    <div class="panel-body">
                      <p>
                        当社は、大切な個人情報をお預かりする企業として、個人情報の保護に関する法律（以下、「個人情報保護法」といいます。）、個人情報保護法に基づいて各所管官庁が作成したガイドライン・指針その他個人情報保護に関連する規範（以下、「関連法令等」といいます。）を遵守します。</p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default panel-help">
                  <a href="#privacy-policy-3" data-toggle="collapse" data-parent="#help-accordion-1">
                    <div class="panel-heading">
                      <h2>3. 個人情報の管理について <i class="fa fa-angle-down fa-lg"></i></h2>
                    </div>
                  </a>
                  <div id="privacy-policy-3" class="collapse">
                    <div class="panel-body">
                      <p>
                        当社は、当社サービスに関するお問い合わせ、当社サービスのお申込み等の際に、利用者の個人情報を取得することがあります。当社は、個人情報の入手を適法かつ公正な手段によって行い、利用者の意思に反する不正な方法により入手しないものとします。</p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default panel-help">
                  <a href="#privacy-policy-4" data-toggle="collapse" data-parent="#help-accordion-1">
                    <div class="panel-heading">
                      <h2>4. 個人情報の利用目的について <i class="fa fa-angle-down fa-lg"></i></h2>
                    </div>
                  </a>
                  <div id="privacy-policy-4" class="collapse">
                    <div class="panel-body">
                      <p>当社は、利用者から得た個人情報について、以下に定める目的に必要な範囲で利用するものとします。</p>
                      <p>(1) 当社サービスをご利用頂く目的、並びに当社サービス及び関連するサービス情報の提供を行う目的</p>
                      <p>(2) 当社サービス提供に関して利用者に対するサポート業務を行う目的</p>
                      <p>(3) 当社に対する利用者からのお問い合わせに対応する目的</p>
                      <p>(4) 当社サイトその他各種媒体等に利用者の情報を掲載するために行う情報の加工、統計及び分析を行う目的</p>
                      <p>(5) 当社サービスの開発及びマーケティングの目的</p>
                      <p>(6) 当社へのお問い合わせ、ご相談及び苦情への対応を行う目的</p>
                      <p>(7) 利用者により良いサービスをご提供するための調査分析及びアンケート調査を実施する目的</p>
                      <p>(8) 利用者の本人確認をする目的</p>
                      <p>(9) 当社サービス及び関連するサービスの立案や改善の参考にする目的</p>
                      <p>(10) メールマガジン、その他利用者に有益と思われる当社サービス等の情報を提供する目的</p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default panel-help">
                  <a href="#privacy-policy-5" data-toggle="collapse" data-parent="#help-accordion-1">
                    <div class="panel-heading">
                      <h2>5. 第三者への個人情報の提供 <i class="fa fa-angle-down fa-lg"></i></h2>
                    </div>
                  </a>
                  <div id="privacy-policy-5" class="collapse">
                    <div class="panel-body">
                      <p>当社は、以下各号の場合において、個人情報を求人企業以外の第三者に提供することがあります。</p>
                      <p>(1) 利用者の同意を得た上で個人情報を提供、開示又は利用する場合</p>
                      <p>(2) 当社が、利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託する委託先に提供する場合</p>
                      <p>(3)
                        利用目的の達成に必要な範囲内において、当社サービスの共同運営会社、その他弊社とパートナーシップ関係にあり、情報の共有に関して守秘義務を定めた契約を締結している第三者に提供する場合</p>
                      <p>(4)
                        個人情報を特定の者と共同利用する場合であって、その旨、共同利用の項目、共同利用者の範囲、共同利用者の利用目的、当該個人情報の管理責任者の氏名又は名称について、あらかじめ利用者に通知し、若しくは利用者が容易に知りうる状態に置いている場合</p>
                      <p>(5) 人の生命、身体又は財産の保護のために必要がある場合であって、利用者の同意を得ることが困難である場合</p>
                      <p>(6) 公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、利用者の同意を得ることが困難である場合</p>
                      <p>(7)
                        国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、利用者の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合</p>
                      <p>(8) 当社が行った集計及び分析等により得られた情報を、個人を識別又は特定できない態様にて提携先等第三者に開示又は提供する場合</p>
                      <p>(9) 利用者が当社において別途定める当社サービスに関する利用規約に違反し、当社及び当社従業員の権利、財産、サービス等を保護するために、必要と認められる場合</p>
                      <p>(10) 法令に基づき開示しなければならない場合</p>
                      <p>(11) 裁判所の発する令状その他裁判所の決定、命令又は法令に基づき開示する場合</p>
                      <p>(12) 検察・警察・監督官庁からの適法・適式な手順により情報の照会があった場合</p>
                      <p>(13) 合併、事業譲渡等事業の承継に伴って個人情報が提供される場合</p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default panel-help">
                  <a href="#privacy-policy-6" data-toggle="collapse" data-parent="#help-accordion-1">
                    <div class="panel-heading">
                      <h2>6. 個人情報の適正管理 <i class="fa fa-angle-down fa-lg"></i></h2>
                    </div>
                  </a>
                  <div id="privacy-policy-6" class="collapse">
                    <div class="panel-body">
                      <p>
                        当社は、利用目的の達成に必要な範囲内において、個人情報を正確かつ最新の状態で管理するよう努めるとともに、個人情報への不正なアクセス又は個人情報の紛失、破壊、改竄、漏洩などの危険に対して、技術面及び組織面において必要な安全対策を継続的に講じるよう努めます。また、当社は、個人情報の安全管理が図られるよう、従業者に対する必要かつ適切な教育及び監督を行います。なお、個人情報はサービスを終了した後も関連法令等の定めに従い一定期間保管します。保管期間が経過した個人情報はすみやかに消去します。</p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default panel-help">
                  <a href="#privacy-policy-7" data-toggle="collapse" data-parent="#help-accordion-1">
                    <div class="panel-heading">
                      <h2>7. Facebook等の外部サービスについて <i class="fa fa-angle-down fa-lg"></i></h2>
                    </div>
                  </a>
                  <div id="privacy-policy-7" class="collapse">
                    <div class="panel-body">
                      <p>
                        当社は、利用者の同意を得てFacebook等の外部サービス(以下「外部サービス」といいます)と連携してサービスを提供する場合があり、利用者が、外部サービスで個人情報その他の利用者情報を公開し、又は外部サービスと連携するサービス上での個人情報その他の利用者情報の利用を許諾した場合、当社においても個人情報その他の利用者情報を利用し、公開する場合があります。情報の公開範囲、公開、非公開の設定等については外部サービスのプライバシーポリシー、利用規約等をご確認頂きますようお願い致します。</p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default panel-help">
                  <a href="#privacy-policy-8" data-toggle="collapse" data-parent="#help-accordion-1">
                    <div class="panel-heading">
                      <h2>8. クッキー（Cookies）について <i class="fa fa-angle-down fa-lg"></i></h2>
                    </div>
                  </a>
                  <div id="privacy-policy-8" class="collapse">
                    <div class="panel-body">
                      <p>
                        当社サイトでは、利用者に当社サービスを便利にご利用頂くためにクッキーと呼ばれる機能を使用することがあります。クッキーとは、Webサーバより利用者のWebブラウザに送信されるデータを格納する仕組み等を指します。クッキー情報については、それら単独では特定の個人を識別することができないため、基本的には個人情報とは考えておりませんが、クッキー情報と個人情報が一体となって使用される場合には、クッキー情報についても個人情報とみなし、本ポリシーに従って取り扱うものとします。</p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default panel-help">
                  <a href="#privacy-policy-9" data-toggle="collapse" data-parent="#help-accordion-1">
                    <div class="panel-heading">
                      <h2>9. アクセスログファイルの取扱いについて <i class="fa fa-angle-down fa-lg"></i></h2>
                    </div>
                  </a>
                  <div id="privacy-policy-9" class="collapse">
                    <div class="panel-body">
                      <p>
                        当社は、当社サイトの利用傾向の分析、当社サイトの管理等の目的でアクセスログファイルを使用することがあります。これにより、当社は、利用者が訪問されたWebページ、当該webページ滞在時間、当社サイトにアクセスする直前のWebサイト、利用者のWebページ間の移動遷移の傾向並びにブラウザ及びオペレーティングシステム等についての統計的なサイト利用情報を得ることができますが、利用者個人を特定する情報として利用しないものとします。</p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default panel-help">
                  <a href="#privacy-policy-10" data-toggle="collapse" data-parent="#help-accordion-1">
                    <div class="panel-heading">
                      <h2>10. 外部サイトへのリンクについて <i class="fa fa-angle-down fa-lg"></i></h2>
                    </div>
                  </a>
                  <div id="privacy-policy-10" class="collapse">
                    <div class="panel-body">
                      <p>
                        当社サイトには、外部のWebサイトへのリンクが含まれる場合がありますが、個人情報を共有するものではありません。なお、当該リンク先外部Webサイトにて行われる利用者の個人情報の取得に関しては、本ポリシーの適用範囲に含まれるものではなく、弊社では一切責任を負えませんので、必ずリンク先Webサイトのプライバシーポリシー等個人情報保護方針をご確認頂きますようお願い致します。</p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default panel-help">
                  <a href="#privacy-policy-11" data-toggle="collapse" data-parent="#help-accordion-1">
                    <div class="panel-heading">
                      <h2>11. 個人情報保護の取り組みについて <i class="fa fa-angle-down fa-lg"></i></h2>
                    </div>
                  </a>
                  <div id="privacy-policy-11" class="collapse">
                    <div class="panel-body">
                      <p>当社は、関連法令等の改正や社会情勢の変化に応じ適宜本ポリシーの見直しを行い、改善を図ってまいります。</p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default panel-help">
                  <a href="#privacy-policy-12" data-toggle="collapse" data-parent="#help-accordion-1">
                    <div class="panel-heading">
                      <h2>12. 個人情報の開示、訂正、利用停止、削除の手続き <i class="fa fa-angle-down fa-lg"></i></h2>
                    </div>
                  </a>
                  <div id="privacy-policy-12" class="collapse">
                    <div class="panel-body">
                      <p>
                        当社は､利用者がご自身の個人情報の開示・訂正・利用停止・削除などを希望される場合、お申し出頂いた利用者がご本人様であることを確認させて頂いた上で、合理的な期間及び範囲内においてお手続きをさせて頂きます。但し、以下各号に掲げる事項にあたる場合は、その全部又は一部を開示しないことがあります。</p>
                      <p>(1) 人の生命･身体･財産その他の権利を害するおそれがあるとき</p>
                      <p>(2) 弊社の適正な業務遂行に著しい支障を及ぼすおそれがあるとき</p>
                      <p>(3) その他法令に違反するとき</p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default panel-help">
                  <a href="#privacy-policy-13" data-toggle="collapse" data-parent="#help-accordion-1">
                    <div class="panel-heading">
                      <h2>13. 個人情報に関するお問い合わせ窓口 <i class="fa fa-angle-down fa-lg"></i></h2>
                    </div>
                  </a>
                  <div id="privacy-policy-13" class="collapse">
                    <div class="panel-body">
                      <p>個人情報に関するお問い合わせにつきましては、以下にて受け付けております。</p>
                      <p>・お問い合わせ先窓口：合同会社E3　個人情報保護問合せ窓口担当者</p>
                      <p>・メールアドレス：info@e3-pro.com</p>
                      <p>・電話番号：050-5328-6890 （祝祭日・年末年始を除く月～金の10時～18時）</p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default panel-help">
                  <a href="#privacy-policy-14" data-toggle="collapse" data-parent="#help-accordion-1">
                    <div class="panel-heading">
                      <h2>14. 本ポリシーの変更 <i class="fa fa-angle-down fa-lg"></i></h2>
                    </div>
                  </a>
                  <div id="privacy-policy-14" class="collapse">
                    <div class="panel-body">
                      <p>
                        当社は、利用者に対する事前の予告なく必要に応じて本ポリシーを変更することができるものとします。変更後の内容は、当社サイトにおいて掲載するものとし、当該掲載後において当社サービスを継続して利用している利用者は、変更後の本ポリシーの内容に同意したものとみなします。</p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default panel-help">
                  <a href="#privacy-policy-15" data-toggle="collapse" data-parent="#help-accordion-1">
                    <div class="panel-heading">
                      <h2>15. 準拠法 <i class="fa fa-angle-down fa-lg"></i></h2>
                    </div>
                  </a>
                  <div id="privacy-policy-15" class="collapse">
                    <div class="panel-body">
                      <p>本ポリシーは、日本法に準拠して解釈又は適用されるものとします。</p>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default panel-help">
                  <a href="#privacy-policy-16" data-toggle="collapse" data-parent="#help-accordion-1">
                    <div class="panel-heading">
                      <h2>16. 合意管轄 <i class="fa fa-angle-down fa-lg"></i></h2>
                    </div>
                  </a>
                  <div id="privacy-policy-16" class="collapse">
                    <div class="panel-body">
                      <p>本ポリシーに関する一切の紛争については、その訴額に応じて東京簡易裁判所又は東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {};
</script>

<style scoped>
  p {
    margin: 16px 0 16px !important;
  }

  .fa {
    float: right;
  }

  .container {
    margin-top: 30px;
  }

  .list-group.help-group {
    margin-bottom: 80px;
    padding-left: 0;
    margin: 0;
  }

  .list-group.help-group .faq-list {
    display: block;
    top: auto;
    margin: 0 0 32px;
    border-radius: 2px;
    border: 1px solid #ddd;
    box-shadow: 0 1px 5px rgba(85, 85, 85, 0.15);
  }

  .list-group.help-group .faq-list .list-group-item {
    position: relative;
    display: block;
    margin: 0;
    padding: 13px 16px;
    background-color: #fff;
    border: 0;
    border-bottom: 1px solid #ddd;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    color: #616161;
    transition: background-color 0.2s;
  }

  .list-group.help-group .faq-list .list-group-item i.mdi {
    margin-right: 5px;
    font-size: 18px;
    position: relative;
    top: 2px;
  }

  .list-group.help-group .faq-list .list-group-item:hover {
    background-color: #f6f6f6;
  }

  .list-group.help-group .faq-list .list-group-item.active {
    background-color: #f6f6f6;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.87);
  }

  .list-group.help-group .faq-list .list-group-item:last-of-type {
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    border-bottom: 0;
  }

  .tab-content.panels-faq {
    padding: 0;
    border: 0;
  }

  .panel.panel-help {
    box-shadow: 0 1px 5px rgba(85, 85, 85, 0.15);
    padding-bottom: 0;
    border-radius: 2px;
    overflow: hidden;
    background-color: #fff;
    margin: 0 0 16px;
  }

  .panel.panel-help a[href^="#"],
  .panel.panel-help a[href^="#"]:hover,
  .panel.panel-help a[href^="#"]:focus {
    outline: none;
    cursor: pointer;
    text-decoration: none;
  }

  .panel.panel-help .panel-heading {
    background-color: #f6f6f6;
    padding: 0 16px;
    line-height: 48px;
    border-top-right-radius: 2px;
    border-top-left-radius: 2px;
    color: rgba(0, 0, 0, 0.87);
  }

  .panel.panel-help .panel-heading h2 {
    margin: 0;
    padding: 14px 0 14px;
    font-size: 18px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0;
    text-transform: none;
  }

  .panel.panel-help .panel-body {
    background-color: #fff;
    border-top: 1px solid #ddd;
    border-radius: 2px;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    margin-top: 0;
  }

  .panel.panel-help .panel-body p {
    margin: 0 0 16px;
  }

  .panel.panel-help .panel-body p:last-of-type {
    margin: 0;
  }

  .inquryimg {
    margin-top: 60px;
  }

  .inqurylabel {
    font-size: 1rem;
    font-weight: 500;
    margin-top: 15px;
  }

  .inqueryselectbox {
    width: 240px;
    height: 40px;
    border-radius: 6.4px;
    background-color: #ffffff;
    border: solid 1px #e4e4e6;
  }

  .ispanel {
    float: left;
  }

  .inqurytextarea {
    width: 100%;
    height: 240px;
    border-radius: 6.4px;
    background-color: #f0f2f4;
    border: solid 1px #e6e8ea;
  }

  .eachinquryline {
    margin-top: 20px;
  }

  .submitinqury {
    width: 100%;
    height: 56px;
    margin-top: 10px;
  }

  @media screen and (max-width: 768px) {
    .inquryimg {
      margin-top: 0px;
      text-align: center;
    }
  }

  @media screen and (max-width: 575.98px) {
    .inquryimg {
      margin-top: 0px;
      text-align: center;
      /*width: 80%;*/
    }
  }

  @media only screen and (min-width: 960px) {
    .inquryimg {
      margin-top: 20px;
      text-align: center;
      /*width: 80%;*/
    }
  }
</style>
